import styled from 'styled-components';

export const ContainerPublicity = styled.section`
    display: flex;
    flex-direction: column;
    padding: 24px;
    width: 100%;
    gap: 24px;
    border-radius: 8px;
    opacity: 0px;
    background: #F4F6F8;
    margin-top: 1rem;

    @media (min-width: 1200px) {
        flex-direction: row;
    }
`;

export const WrapperPublicity = styled.section`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    gap: 0.5rem;
    flex-direction: column;
`;

export const TitlePublicity = styled.h5`
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.36px;
    text-align: left;
    max-width: 241px;
`;

export const SubtitlePublicity = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    max-width: 241px;
`;

export const ContainerStore = styled.section`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
`;

export const Store = styled.img`
    height: 40px;
    object-fit: fill;
`;
